import { Component, OnInit } from '@angular/core';
import { SpinnerService } from '../services/spinner.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {
  isLoading: boolean = false;  // Variable que controla si el spinner se muestra

  constructor(private spinnerService: SpinnerService) {}

  ngOnInit(): void {
    // Suscribirse a los cambios en el observable del SpinnerService
    this.spinnerService.loading$.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
  }
}